import { Text as PrimerText, TextProps as PrimerTextProps } from '@primer/react';

type Props = { as?: any } & PrimerTextProps;

const Text = ({ as, ...props }: Props) => <PrimerText as={as} {...props} />;

export default Text;
export type { Props as TextProps };
